import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import RouterComponent from './routes/Router';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { NotificationProvider } from './context/NotificationContext';
import { Toaster } from 'react-hot-toast';

import GlobalModalManager from './components/common/GlobalModalManager';

function App() {
  return (
    <ThemeProvider>
      <NotificationProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster position="top-right" />
            <GlobalModalManager />
            <RouterComponent />
          </BrowserRouter>
        </AuthProvider>
      </NotificationProvider>
    </ThemeProvider>
  );
}

export default App;
